import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/states/${ view }.vue`);
}


const Index = loadView( 'Index' );
const ViewState = loadView( 'View' );

const stateRoutes = [
    {
        path: 'states',
        name: 'api.state.getList',
        component: Index,
        meta: {
            middleware: permission,
            transitionName: 'slide',
        }
    },
    {
        path: 'states/:id',
        name: 'api.state.get',
        component: ViewState,
        meta: {
            middleware: permission,
            transitionName: 'slide',
        }
    }
];
export default stateRoutes;
